<form [formGroup]="groupKeyForm" class="p-6 flex flex-col gap-5">
  <div class="flex justify-between align-items-center">
    <ng-container *ngIf="!isNameEditing; else editMode">
      <div class="flex gap-2 items-center justify-center text-xl font-semibold">
        <h2>{{ groupKeyForm.get("cheTxNome")?.value }}</h2>
        <fa-icon class="ml-2 cursor-pointer" icon="pen" (click)="enableNameEdit()" />
      </div>
    </ng-container>

    <ng-template #editMode>
      <input class="!w-1/3" (blur)="disableNameEdit()" sigecom-input #nameInput formControlName="cheTxNome"
        (keydown.enter)="disableNameEdit()" />
    </ng-template>



    <div class="flex gap-2">
      <sigecom-button class="text-sigecom-info" icon="sitemap" (buttonClicked)="navigateToGamesTable()"
        title="TABELA DE JOGOS"></sigecom-button>
      <sigecom-button class="text-sigecom-info" icon="list" routerLink=""
        title="VISUALIZAÇÃO DINÂMICA (ELIMINATÓRIA)"></sigecom-button>

      <sigecom-button (buttonClicked)="navigateToFase(petNrId)" class="text-sigecom-info" icon="list"
        title="voltar"></sigecom-button>
    </div>
  </div>

  <div class="flex gap-2 shadow-lg p-4 px-5 bg-white rounded-lg">
    <sigecom-input-container class="w-full" label="Quantidade de Inscrições:" [isDisabled]="hasClashes">
      <input sigecom-input type="number" placeholder="Digite..." formControlName="cheNrQtdInc" name="cheNrQtdInc" />
    </sigecom-input-container>
    <div class="flex flex-col w-full">
      <sigecom-input-container class="w-full" label="Quantidade de Classificações:" [isDisabled]="hasClashes"
        [errorMessage]="
          groupKeyForm.hasError('superioreAInscritos')
            ? 'A quantidade de classificados não pode ser maior que a de inscritos.'
            : ''
        ">
        <input sigecom-input type="number" placeholder="Digite..." formControlName="cheNrQtdVencedor"
          name="cheNrQtdVencedor" />
      </sigecom-input-container>
    </div>
    <sigecom-button [disabled]="!petBlockEdit" title="Salvar" type="info" icon="check" [class]="'h-full w-32'"
      (buttonClicked)="saveInfo()" [disabled]="groupKeyForm.invalid" />
  </div>
  <div>
    <div class="flex justify-between">
      <sigecom-tabs [tabs]="['Participantes', 'Classificação']" (selectedTabChange)="changeTab($event)"
        [(selectedTab)]="selectedTab" />
      <!--<div *ngIf="
          abaSelecionada.match('Confrontos') ||
          abaSelecionada.match('Participantes')
        ">
        <sigecom-button (buttonClicked)="
            abaSelecionada.match('Confrontos')
              ? drawClashesGeneral()
              : allParticipantsAvaliableDraw()
          " class="text-sigecom-info" icon="shuffle" [title]="true ? 'SORTEAR TODOS' : 'SORTEANDO...'" />
      </div>-->
    </div>
    <div class="bg-white w-full shadow-lg p-6 rounded-b-lg rounded-r-lg">
      <div *ngIf="selectedTab === 'Participantes'">
        <div class="flex justify-between items-center">
          <div *ngIf="incricoesChaveamentoPage" class="flex flex-col w-full gap-3">
            <sigecom-list-item *ngFor="let item of inscritos(); let i = index"
              class="flex justify-between w-full items-center" bgColor="bg-sigecom-item-selected">
              <div *ngIf="!incricoesChaveamentoPage!.content![i]" class="flex flex-row gap-3">
                <sigecom-button (buttonClicked)="openModalAddRegistrations()" class="text-sigecom-info" icon="plus"
                  title="DEFINIR PARTICIPANTE" />
                <sigecom-button [disabled]="drawAnimations[i]!.geral!" (buttonClicked)="generalDraw(i)" icon="shuffle"
                  class="text-sigecom-info" [title]="
                    drawAnimations[i]!.geral! ? 'SORTEANDO...' : 'SORTEIO GERAL'
                  "></sigecom-button>

                <!-- <sigecom-button [disabled]="drawAnimations[i]!.cabeca!" (buttonClicked)="headDraw(i)" icon="shuffle"
                  class="text-sigecom-info" [title]="
                    drawAnimations[i]!.cabeca!
                      ? 'SORTEANDO...'
                      : 'SORTEIO CABEÇA DE CHAVE'
                  "></sigecom-button>

                <sigecom-button [disabled]="drawAnimations[i]!.naoCabeca!" (buttonClicked)="notHeadDraw(i)"
                  icon="shuffle" class="text-sigecom-info" [title]="
                    drawAnimations[i]!.naoCabeca
                      ? 'SORTEANDO...'
                      : 'SORTEIO NÃO CABEÇA DE CHAVE'
                  "></sigecom-button> -->
              </div>

              <ng-container *ngIf="(incricoesChaveamentoPage.content)![i]">
                <div class="flex justify-between">
                  <div class="flex gap-2">
                    <div class="bg-[#012169] flex justify-center p-2 items-center w-6 h-6 rounded-full" *ngIf="
                        (incricoesChaveamentoPage.content)![i]
                          .inscricaoEtapaDto.incBlCabecaChave
                      ">
                      <fa-icon class="text-[#E9CA26] text-xs" icon="key"></fa-icon>
                    </div>
                    <p class="w-full font-semibold">
                      {{
                      incricoesChaveamentoPage!.content![i].inscricaoEtapaDto
                      .ineObjInscricao.incTxResumo
                      }}
                    </p>
                  </div>

                  <sigecom-menu-bar-item (clickAction)="
                      deleteParticipant(
                        incricoesChaveamentoPage!.content![i].inscricaoEtapaDto
                          .ineNrId
                      )
                    " icon="trash" color="sigecom-danger" title="Apagar" />
                </div>
              </ng-container>
            </sigecom-list-item>

            <div class="h-32 flex items-center justify-center"
              *ngIf="incricoesChaveamentoPage.empty && inscritos().length == 0">
              <div class="h-full flex items-center text-[#787878]">
                Preencha a quantidade de Inscrições do grupo.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4" *ngIf="abaSelecionada === 'Confrontos' && clashListDto.content">
        <sigecom-list-item *ngIf="!groupKeyDto?.cheBlEmbGerados" ngClass="flex" bgColor="bg-sigecom-item-selected">
          <div class="flex gap-2">
            <sigecom-button [disabled]="!petBlockEdit" (buttonClicked)="openModalAddParticipants(undefined)"
              class="text-sigecom-info" icon="plus" title="DEFINIR PARTICIPANTES" />

            <sigecom-button [disabled]="!petBlockEdit" (buttonClicked)="drawClashes()" class="text-sigecom-info"
              icon="shuffle" title="SORTEIO" />
          </div>
        </sigecom-list-item>

        <div *ngFor="let item of clashListDto.content">
          <sigecom-list-item bgColor="bg-sigecom-item-selected">
            <div class="flex justify-between items-center">
              <div class="flex w-full flex-col gap-2">
                <div class="flex gap-2 flex-wrap">
                  <div *ngFor="
                      let item of item.embListInscricaoDto;
                      let last = last
                    " class="flex">
                    <div class="font-semibold text-[#333333] items-center justify-center w-full flex gap-2">
                          <!-- item.embateDto!.inscricaoEtapaDto.incBlCabecaChave! -->
                      <div class="bg-[#012169] flex justify-center items-center w-6 max-h-8 rounded-full" *ngIf="
                          false
                        ">
                        <fa-icon class="text-[#E9CA26] text-sm" icon="key"></fa-icon>
                      </div>
                      <p>
                        {{
                        item.embateDto!.inscricaoEtapaDto.ineObjInscricao
                        .incTxResumo
                        }}
                      </p>
                      <span class="font-bold" *ngIf="!last">x</span>
                    </div>
                  </div>
                  <sigecom-menu-bar-item (clickAction)="openModalAddParticipants(item.embNrId)"
                    class="text-sigecom-info" icon="plus" color="sigecom-info" title="Adicionar" />
                </div>
                <div class="flex flex-col text-[#787878] gap-2 sm:flex-row sm:gap-6">
                  <p class="font-semibold">
                    Local de Competição:
                    <span class="font-normal">
                      Arena fonte nova
                      <!-- {{ item.embListInscricaoDto || 'Não informado' }} -->
                    </span>
                  </p>
                  <p class="font-semibold">
                    Espaço:
                    <span class="font-normal">
                      Quadra
                      <!-- {{ item.embListInscricaoDto || 'Não informado' }} -->
                    </span>
                  </p>
                  <p class="font-semibold">
                    Data:
                    <span class="font-normal">
                      20 horas
                      <!-- {{ item.embListInscricaoDto }} -->
                    </span>
                  </p>
                </div>
              </div>
              <div *ngIf="item.embBlResultadoDefinido" class="flex items-center gap-4 pr-4">
                <sigecom-chip-tag [status]="TagStatusEnum.CONCLUIDO" text="Placar definido"></sigecom-chip-tag>
              </div>
              <div class="flex gap-3">
                <sigecom-menu-bar-item (clickAction)="openlocalCompetition()" icon="location-dot" color="sigecom-info"
                  title="Local de competição" />
                <sigecom-menu-bar-item (clickAction)="openScoreboard(item)" icon="trophy" color="sigecom-info"
                  title="Placar" />
                <sigecom-menu-bar-item (clickAction)="deleteCompetiton(item)" icon="trash" color="sigecom-danger"
                  title="Delete" />
              </div>
            </div>
          </sigecom-list-item>
        </div>

        <sigecom-pagination-list *ngIf="clashListDto.content.length" class="mt-7"
          [totalPages]="clashListDto.totalPages!" [maxDisplayedPages]="maxDisplayedPages"
          (pageChange)="onPageChange($event)" />
      </div>

      <div *ngIf="selectedTab === 'Classificação'">
        <sigecom-classification (dadosOut)="setDadosClassification($event)" [clickAction]="modalViewClassification"
          (clickActionEmit)="abrirModal($event)" titleIcon="Visualizar participante" iconButton="eye"
          colunaWith="Participante" [colunas]="colunas" [dados]="classificationDto?.content || []"
          [cheQtdVencedores]="cheQtdVencedores" />
      </div>
    </div>
  </div>
</form>

<sigecom-modal class="w-[10rem]" [open]="modalAddParticipants" [showCloseButton]="true"
  (modalStateChange)="closeModalAddParticipants()">
  <p class="text-lg font-semibold text-[#787878]">
    Adicionar participantes - Definir confronto
  </p>
  <sigecom-modal-add-participants [embNrId]="embNrId" (participantAdded)="participantAdded()"
    *ngIf="modalAddParticipants" (viewParticipants)="openModalViewParticipants($event)" (parNrId)="(parNrId)" />
</sigecom-modal>

<!-- <sigecom-modal class="w-[10rem]" [open]="modalAddRegistrations" [showCloseButton]="true"
  (modalStateChange)="closeModalAddRegistrations()">
  <p class="text-lg font-bold text-sigecom-dark-gray">
    Adicionar participantes
  </p>
  <sigecom-modal-add-registrations-for-key (viewRegistrations)="openModalViewRegistrations($event)"
    (parNrId)="(parNrId)" />
</sigecom-modal> -->

<!-- <sigecom-modal class="w-[10rem]" [open]="viewParticipants || viewRegistrations" [showCloseButton]="true"
  (modalStateChange)="closeModalViewParticipants()">
  <p class="text-lg font-bold text-sigecom-dark-gray">
    Informações do participante
  </p>

  <div class="flex items-center gap-3 min-w-[50rem] min-h-[20rem]">
    <div *ngIf="!parNrId">
      <p>Nenhum participante selecionado</p>
    </div>
  </div>
  <sigecom-modal-add-participants
    (viewParticipants)="openModalViewParticipants()"
    (incNrId)="(incNrId)"
  />
</sigecom-modal> -->

<sigecom-modal class="w-[10rem]" [open]="modalAddRegistrations" [showCloseButton]="true"
  (modalStateChange)="closeModalAddRegistrations()">
  <p class="text-lg mb-3 font-semibold text-sigecom-dark-gray pb-2">
    Adicionar participantes
  </p>
  <sigecom-modal-add-registrations-for-key *ngIf="modalAddRegistrations" [petNrId]="petNrId" [cheNrId]="cheNrId"
    (viewRegistrations)="openModalViewRegistrations($event)" />
</sigecom-modal>

<sigecom-modal class="w-[10rem]" [open]="viewParticipantInfo" [showCloseButton]="true"
  (modalStateChange)="closeModalViewParticipants()">
  <sigecom-modal-equipe *ngIf="viewParticipantInfo" [incNrId]="incNrId!" (atlNrId)="setAtlNrId($event)"
    (modalDetailParticipant)="openModalDetailParticipant()"></sigecom-modal-equipe>
</sigecom-modal>

<sigecom-modal class="w-[10rem]" [open]="viewParticipantDetail" [showCloseButton]="true"
  (modalStateChange)="closeModalViewParticipants()">
  <sigecom-modal-participante [atlNrId]="atlNrId" *ngIf="viewParticipantDetail"></sigecom-modal-participante>
</sigecom-modal>

<sigecom-modal [open]="modalArena" [showCloseButton]="true" (modalStateChange)="closelocalCompetition()">
  <p class="text-lg font-bold text-sigecom-dark-gray">
    Selecionar Local de Competição
  </p>
  <sigecom-modal-arena />
</sigecom-modal>

<sigecom-modal class="rounded-xl" [open]="modalPlacar" [showCloseButton]="false"
  (modalStateChange)="closeModalScoreboard()">
  <sigecom-scoreboard (closeModalScoreboard)="closeModalScoreboard()" *ngIf="modalPlacar" [teams]="teams!"
    [cheNrId]="cheNrId"></sigecom-scoreboard>
</sigecom-modal>

<sigecom-new-modal-classification [dados]="classification" class="w-[40rem] h-[20rem]"
  [(show)]="modalViewClassification" />
